export const isProd = true;
export const WEB_SERVICE_URL = isProd=== true ? "/back/admin/":"http://localhost:5000/admin/";
export const ASSETS = "/assets/";
export const CDNURL = 'http://cookieconsent.gulenayva.com/cookie-bundle.js?key=';